import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface roleSlice {
  data: {} | null;
  token: string | null;
  userType: string | null;
}

const initialState: roleSlice = {
  data: null,
  token: null,
  userType: null,
};

export const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    setUserRole: (state, action) => {
      state.data = action.payload.data;
      state.token = action.payload.token;
      state.userType = action.payload.userType;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setUserRole, reset } = roleSlice.actions;
export const getRole = (state: any) => state.role.data;
export const getUserType = (state: any) => state.role.userType;
export const getUserId = (state: any) => state.role.data?.id;

export default roleSlice.reducer;
